import React from "react";

/**
 * Lightweight, brand-consistent loading state shown while a lazy route
 * chunk is downloading. Uses only inline styles so it renders instantly
 * without waiting for the design-system CSS chunk.
 */
const PageFallback: React.FC = () => (
  <div
    role="status"
    aria-live="polite"
    aria-label="Chargement"
    style={{
      minHeight: "50vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: "3rem 1rem",
    }}
  >
    <span
      aria-hidden="true"
      style={{
        width: 44,
        height: 44,
        borderRadius: "50%",
        border: "3px solid rgba(15, 118, 189, 0.18)",
        borderTopColor: "hsl(195 60% 28%)",
        animation: "sabaody-spin 0.8s linear infinite",
        display: "inline-block",
      }}
    />
    <style>{`@keyframes sabaody-spin{to{transform:rotate(360deg)}}`}</style>
  </div>
);

export default PageFallback;
